




























































import { Vue, Component } from "vue-property-decorator";
import { notificationModule } from "@/store/modules/notification";

@Component
export default class Notification extends Vue {
  public switchMask = true;
  get loading() {
    return notificationModule.loading;
  }

  get notifications() {
    return notificationModule.notifications;
  }

  async created() {
    await notificationModule.getNotificationList();
  }
}
